import React, { createRef } from "react";
import { observer } from "mobx-react";
import { Modal, Row, Col, Form, Button, Table, Pagination } from "react-bootstrap";
import { CreateEditCustomerOrderStore, Part, RussianCarPartBrandInfo, RussianCarPartItem } from "../../../../stores";
import { wrapInput } from "../../../../common/FormChangeWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IProps {
    createEditStore: CreateEditCustomerOrderStore;
    isOpened: boolean;
    clientId: string;
    source: string;
    onClose: () => void;
    addPositionToOrder: (part: Part, count: number) => void;
    switchToArticleSearch: () => void;
}

interface IState {
    searchString: string;
    searchId: string;
    selectedBrandId?: number;
    page: number;
    totalCount: number;
    letters: string[];
    brands: RussianCarPartBrandInfo[];
    positions: RussianCarPartItem[];
    selectedCharacter: string;
}

@observer
export class AddRussianCarPositionModal extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            searchId: "",
            searchString: "",
            page: 1,
            brands: [],
            positions: [],
            letters: [],
            selectedCharacter: "",
            totalCount: 0
        };

    }

    private articleTextEditRef = createRef<any>();


    componentDidMount() {
        // this.searchParts();
    }

    componentDidUpdate(prevProps: IProps, prevState: IState, snapshot: any) {
        if (!prevProps.isOpened && this.props.isOpened) {
            this.searchParts();
        }
    }

    searchParts = () => {
        this.props.createEditStore.searchRussianCarParts(
            this.state.searchId,
            this.props.clientId,
            this.props.source,
            this.state.searchString,
            this.state.selectedBrandId,
            this.state.selectedCharacter,
            (positions: RussianCarPartItem[], searchId: string, page: number, totalCount: number, brands: RussianCarPartBrandInfo[], letters: string[]) => {
                this.setState({
                    searchId: searchId,
                    page: page,
                    totalCount: totalCount,
                    brands: brands,
                    letters: letters,
                    positions: positions
                })
            })
    }


    onChangeSearchString = (fieldName: string, value: string) => {
        this.setState({
            searchString: value
        });
    }

    onChangeBrand = (fieldName: string, value: string) => {
        this.setState({
            selectedBrandId: parseInt(value)
        });
    }
    onChangeLetter = (char: string) => {
        this.setState({
            selectedCharacter: this.state.selectedCharacter === char ? "" : char
        });
    }

    onChangeAddCount = (part: RussianCarPartItem, rowNum: number, newCount: number) => {
        if (newCount > 0) {
            if (newCount !== part.toOrderCount) {
                this.setState({
                    positions: this.state.positions.map((w, index) => {
                        if (index == rowNum) {
                            return Object.assign({}, w, { toOrderCount: newCount });
                        }
                        return w;
                    })
                });
            }
        }
    }


    render() {
        return <Modal show={this.props.isOpened} onHide={this.props.onClose} className="modal-xxl" key={"1"} >
            <Modal.Header closeButton>
                <Modal.Title>
                    Добавление позиции в заказ
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col sm={12}>
                        <Form inline onSubmit={(e: any) => {
                            e.preventDefault();
                        }}>
                            <Form.Group controlId="formSearch">
                                <Form.Control size="sm"
                                    ref={this.articleTextEditRef}
                                    type="text" value={this.state.searchString}
                                    onChange={wrapInput(this.onChangeSearchString)}
                                    placeholder="Введите описание или артикул..."
                                    style={{ width: "250px" }}
                                    autoComplete="off" />
                            </Form.Group>
                            <Form.Group controlId="formSearch">
                                <Form.Control as="select" size="sm" style={{ marginLeft: "5px" }}
                                    onChange={wrapInput(this.onChangeBrand)}>
                                    <option>Выберите бренд...</option>
                                    {this.state.brands.map((w, index) => <option key={index} value={w.brandId}>
                                        {w.brandName}
                                    </option>)}
                                </Form.Control>
                            </Form.Group>

                            <Button size="sm" type="submit" style={{ marginLeft: "10px" }} onClick={this.searchParts}
                            >
                                <FontAwesomeIcon icon='search' />{' '}Поиск
                            </Button>
                            <Form.Check inline style={{ marginLeft: "30px" }}
                                label="По артикулу" type="radio" value="article"
                                defaultChecked={false}
                                onClick={this.props.switchToArticleSearch} />
                            <Form.Check inline
                                label="По русским авто" type="radio" value="russian"
                                defaultChecked={true}
                            />

                        </Form>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col sm={12} style={{ minHeight: "200px" }}>
                        <Pagination size="sm">
                            {this.state.letters.map((w) => <Pagination.Item key={w} active={this.state.selectedCharacter === w}
                                onClick={() => this.onChangeLetter(w)}>
                                {w}
                            </Pagination.Item>)}
                        </Pagination>

                        <Table bordered striped className="table-xxs">
                            <thead>
                                <tr>
                                    <th className="text-center">Поставщик</th>
                                    <th className="text-center">Бренд</th>
                                    <th className="text-center">Артикул</th>
                                    <th>Наименование</th>
                                    <th className="text-center">Остаток</th>
                                    <th style={{ width: "75px", cursor: "pointer" }} className="text-center">
                                        Срок
                                    </th>
                                    <th style={{ cursor: "pointer" }} className="text-center">
                                        Цена
                                    </th>
                                    <th className="text-center"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.positions.map((item, index) => <tr key={index}>
                                    <td className="text-center">{item.supplierCode}</td>
                                    <td className="text-center">{item.brandName}</td>
                                    <td className="text-center">{item.article}</td>
                                    <td>{item.description}</td>
                                    <td className="text-center">{item.count}</td>
                                    <td className="text-center">{item.deliveryTimeString}</td>
                                    <td className="text-center">{item.price}</td>
                                    <td className={"text-center" + ((item.count < item.toOrderCount) ? " table-danger" : "")} style={{ width: "225px", margin: "0 auto" }}>
                                        <div className="form-inline">
                                            <Form.Control type="number"
                                                value={item.toOrderCount.toString()}
                                                size="sm"
                                                style={{ width: "60px", marginRight: "10px" }}
                                                onChange={wrapInput((fieldName: string, value: string) => {
                                                    this.onChangeAddCount(item, index, parseInt(value))

                                                })}
                                            />
                                            <Button type="button" variant="primary" size="sm" disabled={item.count < item.toOrderCount}
                                                onClick={() => { }}>
                                                <FontAwesomeIcon icon="plus" />{' '}Добавить в заказ
                                            </Button>
                                        </div>
                                    </td>
                                </tr>)}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    }
}